import PropTypes from "prop-types";
import React from "react";
import { useHistory } from "react-router-dom";

import styled from "styled-components/macro";

import { useIsFeatureFlagEnabled } from "Giving/ManageMyGivingPage/useIsFeatureFlagEnabled";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import FnrButton3 from "UI/FnrButton3";

ReceiptButton.propTypes = {
  linkView: PropTypes.bool,
};

export default function ReceiptButton({ linkView = false }) {
  const history = useHistory();
  const { state } = usePaymentPage();
  const { paymentParent } = state;
  const { fundColorSafe } = state.fund;
  const receiptButton = paymentParent?.successScreen?.receiptButton;
  const mmgFeatureFlagEnabled = useIsFeatureFlagEnabled();

  if (
    paymentParent?.parent === "signups" &&
    state.submitPaymentResponse.signupUserIsLoggedIn === false
  ) {
    // this is to handle the situation where the signup user and payment user are different.
    // in this case, we don't want to show the receipt button.
    return null;
  }
  if (receiptButton) {
    return (
      <FnrButton3
        onClick={receiptButton?.action}
        style={{ marginTop: "36px", width: "100%" }}
      >
        {receiptButton?.text || "Close"}
      </FnrButton3>
    );
  }

  if (mmgFeatureFlagEnabled && paymentParent?.parent !== "signups") {
    return (
      <>
        {linkView ? (
          <GivingDashboardWrapper>
            <GivingDashMsg>
              To view your gifts or make another donation,{" "}
              <A
                color={fundColorSafe}
                href="/give"
                target="_blank"
                rel="noreferrer"
              >
                visit your giving dashboard.
              </A>
            </GivingDashMsg>
          </GivingDashboardWrapper>
        ) : (
          <GivingDashboardWrapper>
            <GivingDashMsg>
              To view your gifts or make another donation, visit your giving
              dashboard.
            </GivingDashMsg>

            <FnrButton3
              color={fundColorSafe}
              onClick={() => history.push(`/give`)}
              fullWidth
            >
              <NoWrap>My Giving Dashboard</NoWrap>
            </FnrButton3>
          </GivingDashboardWrapper>
        )}
      </>
    );
  }

  return null;
}

const GivingDashboardWrapper = styled.div`
  margin-top: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 36px auto 0;
  max-width: 230px;
`;

const GivingDashMsg = styled.div`
  text-align: center;
  color: #383838;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 0.5rem;
`;

const NoWrap = styled.div`
  white-space: nowrap;
`;

const A = styled("a")`
  color: ${({ color }) => color} !important;
`;
